// 📁 src/components/account/TeamPage.jsx

import React, { useEffect, useState } from 'react';

export default function TeamPage() {
  const [companyName, setCompanyName] = useState('');
  const [tenantId, setTenantId] = useState('');

  useEffect(() => {
    const email = localStorage.getItem('email');
    const registry = JSON.parse(localStorage.getItem('accountRegistry') || '{}');
    const account = registry[email] || {};
    setCompanyName(account.companyName || '');
    setTenantId(account.tenantId || '');
  }, []);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-indigo-700 mb-2">Team Members</h1>
      {(companyName || tenantId) && (
        <div className="mb-4 text-sm text-gray-600 italic">
          {companyName && <div>Company Name: {companyName}</div>}
          {tenantId && <div>Tenant ID: {tenantId}</div>}
        </div>
      )}
      <p>This is a placeholder for the Team Members page.</p>
    </div>
  );
}
